<div class="logo">
  <div>
    <img alt="logo mst" [src]="'assets/img/MSTLOGO.svg'">
  </div>
  <div class="splash_txt">
    MST {{isDev? 'STAGING' :  ''}}
  </div>
</div>
